import React from "react";
import { Alert } from "react-bootstrap";

export default function ProductAlert(props) {
  // Show a warning when the producer only delivers to a local area:
  if (
    props.productAlert !== null &&
    props.productAlert !== "" &&
    props.productAlert !== undefined
  ) {
    return (
      <Alert bsStyle="warning">
        <strong>{props.productAlert}</strong>
      </Alert>
    );
  }

  return null;
}
